import { isTrue } from '@/utils/Common/Booleans';

class PaperlessChatController {
  constructor() {
    this.chatLink = document.querySelector('.js-ken-paperless-chat-link');
    this.chatTooltip = document.querySelector('.js-ken-paperless-chat-tooltip');
    this.hiddenClass = '--hidden';
  }

  openChat(e) {
    e.preventDefault();
    if (isTrue(DLG.snapEngage.isEnabled) && typeof SnapEngage !== 'undefined') {
      if (SnapEngage.getAgentStatus()) {
        SnapEngage.startLink();
      }
      /* eslint-disable no-undef */
    } else if (typeof openMavenoidWidget !== 'undefined') {
      openMavenoidWidget();
      /* eslint-enable no-undef */
    } else if (this.chatTooltip) {
      this.chatTooltip.classList.toggle(this.hiddenClass);
    }
  }

  init() {
    if (this.chatLink) {
      this.chatLink.addEventListener('click', e => this.openChat(e));
    }
  }
}

export const paperlessChatController = new PaperlessChatController();
export default paperlessChatController;
